import {
  GET_TRANSACTIONS_TYPES_REQUEST,
  GET_TRANSACTIONS_TYPES_SUCCESS,
  GET_TRANSACTIONS_TYPES_FAILURE,
  SAVE_CLIENT_TAX_CODES_MANUAL,
  SAVE_CLIENT_TAX_CODES_MANUAL_SUCCESS,
  SAVE_CLIENT_TAX_CODES_MANUAL_FAILURE,
  SAVE_CLIENT_TAX_CODES_MANUAL_RATES,
  SAVE_CLIENT_TAX_CODES_MANUAL_RATES_SUCCESS,
  SAVE_CLIENT_TAX_CODES_MANUAL_RATES_FAILURE,
  CLEAR_SAVED_TAX_RATES,
} from '@constants/action-types/transactionTypes';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const clearClientSavedRates = () => actionRequestFactory(CLEAR_SAVED_TAX_RATES);

export const getTransactionTypesRequest = (
  transactionType,
  limit,
  offset,
  transactionCategory,
  entityJurisdictionId
) =>
  actionRequestFactory(GET_TRANSACTIONS_TYPES_REQUEST, {
    transactionType,
    limit,
    offset,
    transactionCategory,
    entityJurisdictionId,
  });

export const getTransactionTypesSuccess = transactions =>
  actionResponseFactory(GET_TRANSACTIONS_TYPES_SUCCESS, { transactions });

export const getTransactionTypesFailure = error =>
  actionResponseFactory(GET_TRANSACTIONS_TYPES_FAILURE, { error });

export const saveSelectedClientTaxCodes = taxCodes =>
  actionResponseFactory(SAVE_CLIENT_TAX_CODES_MANUAL, taxCodes);

export const saveSelectedClientTaxCodesSuccess = taxCodes =>
  actionResponseFactory(SAVE_CLIENT_TAX_CODES_MANUAL_SUCCESS, taxCodes);

export const saveSelectedClientTaxCodesFailure = error =>
  actionResponseFactory(SAVE_CLIENT_TAX_CODES_MANUAL_FAILURE, { error });

export const saveClientTaxCodeRates = rates =>
  actionResponseFactory(SAVE_CLIENT_TAX_CODES_MANUAL_RATES, rates);

export const saveClientTaxCodeRatesSuccess = rates =>
  actionResponseFactory(SAVE_CLIENT_TAX_CODES_MANUAL_RATES_SUCCESS, rates);

export const saveClientTaxCodeRatesFailure = rates =>
  actionResponseFactory(SAVE_CLIENT_TAX_CODES_MANUAL_RATES_FAILURE, rates);
